import {createChatBotMessage} from 'react-chatbot-kit';
const config = {
      initialMessage: [createChatBotMessage('Welcome to Ezzyship')],
};
export default config;
